<template>
	<article class="home">
		<loading-spinner v-if="! components" />
		<template v-else>
			<top-panel v-if="banner" :banner="banner" :campaignProducts="campaignProducts" />

			<home-component-selector
				v-if="components.length > 0"
				:components="components"
				:toplists="toplists"
				:popularCategories="popularCategories"
				:campaignProducts="campaignProducts"
				:extraData="{
					highlightSection: campaignHighlightSection,
				}"
				class="parent-section"
				:addBannerIndex="banner ? 1 : 0"
			/>
		</template>
	</article>
</template>

<script>
import { shuffle } from 'lodash';
import waja from 'waja';
import bus from 'eventbus';
import store from 'datastore';
import mediaQuery from 'mediaQuery';
import { rollXHighlights, rollXComponents } from 'utils/highlight';
import localSessionStorage from 'localSessionStorage';
import { mapGetters } from 'vuex';
import { t } from 'datastore/i18n';
import { error } from 'utils';

export default {
	store,
	handlesPrerender: true,
	data () {
		return {
			campaignHighlightSection: null,
			highlightSections: null,
			banner: null,
			tickerText: '',
			highlightsLoaded: false,
			topListsLoaded: false,
			products: [],
			components: [],
			toplists: null,
			popularCategories: null,
			campaignProducts: null,
		};
	},
	handleTakeovers: true,
	beforeRouteEnter (to, frm, next) {
		waja.get('highlight/'+store.getters['i18n/regionCode'])
			.useCdn(true)
			.on('success', res => {
				next(vm => {
					vm.components = res.data.homeComponents.components;

					const homeComponents = res.data.homeComponents;
					const highlights = res.data.highlights;

					const toplist = rollXComponents((homeComponents.count['1'] || 0), homeComponents.toplists.filter(el => {
						return el.hasBanner === false;
					}));
					const toplistWithBanner = rollXComponents((homeComponents.count['5'] || 0), homeComponents.toplists.filter(el => {
						return el.hasBanner === true;
					}));

					if (toplistWithBanner && toplistWithBanner.length > 0) {
						vm.toplists = toplist ? toplist.concat(toplistWithBanner) : toplistWithBanner;
					} else {
						vm.toplists = toplist;
					}

					vm.popularCategories = rollXComponents(homeComponents.count['2'], homeComponents.popularCategories);

					const exclusionList = [];
					bus.$emit('takeover:update', rollXHighlights(1, highlights.takeovers));
					vm.banner = rollXHighlights(1, highlights.banners, exclusionList);
					vm.highlightSections = vm.randomizeHighlightSectionOrder(highlights.highlightSections);
					vm.campaignProducts = highlights.campaignProducts;

					if (highlights.highlightCampaigns) {
						let index = 0;
						if (vm.banner) {
							index = highlights.highlightCampaigns.findIndex(light => light.highlightId == vm.banner.highlightId);
						}
						if (index >= 0) {
							highlights.highlightCampaigns.push(highlights.highlightCampaigns.splice(index, 1)[0]);
						}
						highlights.highlightCampaigns = highlights.highlightCampaigns.slice(0,6);
						for (const hl of highlights.highlightCampaigns) {
							exclusionList.push(hl.highlightId);
						}

						vm.campaignHighlightSection = {
							color:'#2a659d',
							highlights: highlights.highlightCampaigns,
							icon: 'kampanjer',
							id: null,
							path: '/campaigns',
							name:'Veckans kampanjer',
						};
					}

					for (const sec of vm.highlightSections) {
						sec.highlights = rollXHighlights(6, sec.highlights, exclusionList);
					}

					Vue.nextTick(() => {
						vm.highlightsLoaded = true;
						vm.onPageLoad();
					});
				});
			})
			.on('error', () => {
				next(error(500, 'Det går för tillfället inte att komma åt denna sida. Försök gärna senare.'));
			}).go();
	},
	computed: {
		showTopLists () {
			if (mediaQuery.current <= mediaQuery.sm) {
				return true;
			}
			return false;
		},
		filteredProducts () {
			if (this.selectedTopList && this.selectedTopList.products.length) {
				return this.selectedTopList.products.slice(0, 8);
			}

			return [];
		},
		...mapGetters({
			isLoggedIn: 'user/isLoggedIn',
			selectedTopList: 'productTips/selectedTopList',
			selectedTopListId: 'productTips/selectedTopListId',
		}),
	},
	methods: {
		randomizeHighlightSectionOrder (sections) {
			let sectionOrder = localSessionStorage.get('highlightSectionOrder');

			let highlightSections = [];

			if (sectionOrder) {
				sectionOrder = sectionOrder.split(',');

				for (const sectionId of sectionOrder) {
					for (const section of sections) {
						if (section.id == sectionId) {
							highlightSections.push(section);
							break;
						}
					}
				}
			} else {
				highlightSections = shuffle(sections);
				sectionOrder = [];
				for (const sec of highlightSections) {
					sectionOrder.push(sec.id);
				}
				localSessionStorage.set('highlightSectionOrder', sectionOrder.join(','));
			}
			return highlightSections;
		},
		onTopListsLoad () {
			this.topListsLoaded = true;
			this.onPageLoad();
		},
		onPageLoad () {
			if (this.highlightsLoaded && this.topListsLoaded) {
				store.dispatch('prerender/pageLoaded');
			}
		},
		t,
		ts: t.prefix('SECTION'),
	},
	mounted () {
		bus.$on('productTips:rendered', this.onTopListsLoad);

		const section = null;
		if (store.getters['productTips/isTopListLoaded'](section)) {
			this.onTopListsLoad();
		}
		store.commit('productTips/setShowTopLists', true);
		store.dispatch('productTips/fetchTopLists', { section });
		store.commit('productTips/setShowLists', false);

	},
	beforeDestroy () {
		bus.$off('productTips:rendered', this.onTopListsLoad);
	},
};
</script>
